import { type FC } from 'react';
import { useCurrentUser } from './useCurrentUser';

// Renders nothing when there is no current user, so that descendants can call useRequiredCurrentUser.
// Sign-out unsets $rootScope.currentUser before the redirect, and react2Angular unmounts the component
// only after the leave animation, so the component re-renders without a user in the meantime.
export function withRequiredCurrentUser<Props extends object>(Component: FC<Props>): FC<Props> {
    const WithRequiredCurrentUser = (props: Props) => {
        const currentUser = useCurrentUser();

        return currentUser ? <Component {...props} /> : null;
    };

    return WithRequiredCurrentUser;
}
